import React, { useEffect, useState } from 'react';
import './Privacypolicy.css';

const PrivacyPolicy = () => {
  const [isVisible, setIsVisible] = useState(false);
  const today = new Date();
  const lastUpdated = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`privacy-policy-container ${isVisible ? 'visible' : ''}`}>
      <div className="privacy-policy-content">
        <header className="privacy-header">
          <div className="header-decoration"></div>
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {lastUpdated}</p>
          <div className="company-info">
            <h2>A Peaceful Retreat
            </h2>

          </div>
        </header>

        <div className="privacy-content">
          {/* 1. Information Collected */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">1</div>
              <h2>Information Collected</h2>
            </div>
            <div className="section-content">
              <p>
                Personal information may be collected when you voluntarily submit it through this website,
                such as your name, email address, phone number, or message content.
              </p>
              <p>
                Certain technical or usage information may also be collected automatically through standard
                website technologies.
              </p>
            </div>
          </section>

          {/* 2. Communications */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">2</div>
              <h2>Communications</h2>
            </div>
            <div className="section-content">
              <p>
                By submitting your contact information or contacting A Peaceful Retreat
                through this website,
                you consent to receive communications by phone, email, or SMS related to your inquiry.
              </p>
              <p>
                Message frequency may vary. Message and data rates may apply. Consent is not a condition
                of purchase.
              </p>
            </div>
          </section>

          {/* 3. Disclosure of Information */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">3</div>
              <h2>Disclosure of Information</h2>
            </div>
            <div className="section-content">
              <p>
                Information collected through this website may be disclosed to third parties as required
                by law or as necessary to operate and maintain the website.
              </p>
            </div>
          </section>

          {/* 4. Data Security */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">4</div>
              <h2>Data Security</h2>
            </div>
            <div className="section-content">
              <p>
                Reasonable measures are used to protect information submitted through this website.
                However, no method of electronic transmission or storage is completely secure.
              </p>
            </div>
          </section>

          {/* 5. Third-Party Websites */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">5</div>
              <h2>Third-Party Websites</h2>
            </div>
            <div className="section-content">
              <p>
                This website may contain links to third-party websites.A Peaceful Retreat
 is not responsible for
                the privacy practices or content of those sites.
              </p>
            </div>
          </section>

          {/* 6. Changes to This Policy */}
          <section className="policy-section">
            <div className="section-header">
              <div className="section-number">6</div>
              <h2>Changes to This Policy</h2>
            </div>
            <div className="section-content">
              <p>
                This Privacy Policy may be updated from time to time. Continued use of the website
                constitutes acceptance of the current version.
              </p>
            </div>
          </section>
        </div>

        <footer className="privacy-footer">
          <p>© {today.getFullYear()} A Peaceful Retreat
. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;